module.exports = __webpack_public_path__ + "img/stock1.e626d0b4.png";